import React from 'react';
import { Link } from 'react-router-dom';
import Scroll from 'react-scroll';
import { getPathWithParams } from '../../../helpers/router';
import { businessRoutes } from '../../../utils/routes';
import Animate from '../Animate';

const Scroller = Scroll.scroller;

const Plan = ({ t, plans, language }) => (
	<div id="plan" className="landing-container-plans">
		<div className="landing-layout">
			<div className="landing-page-plans">
				<div className="landing-list-header">
					<Animate>
						<h2 className="landing-section-title">
							{t("landing.plans.title")}
						</h2>
					</Animate>
					<p className="landing-section-text">
						{t("landing.plans.subtitle")}
					</p>
				</div>
				<div className="landing-plans">
					{plans.map(
						(
							{
								size,
								price,
								days,
								plans,
								amount,
								text,
								price_survey,
								button_text,
							},
							index
						) => (
							<div
								key={index}
								className="landing-plans-container"
							>
								<div className="landing-plans-circle">
									<p>{size}</p>
								</div>
								<p className="landing-plans-price">{price}</p>
								<p className="landing-plans-days">{days}</p>
								<div className="landing-line"></div>
								<div className="landing-text">
									<p>{text}</p>
									<p className="landing-plans-amount">
										{amount}
									</p>
									<p className="landing-plans-plans">
										{plans}
									</p>
									<p className="landing-price-survey">
										{price_survey}
									</p>
								</div>
								<div className="landing-animated pulce">
									{index === 3 ? (
										<button
											style={{ margin: 0 }}
											className="landing-link"
											onClick={() => {
												Scroller.scrollTo(
													'scrollToContact',
													{
														duration: 1000,
														smooth: 'easeInOutCubic',
														offset: 0,
													}
												);
											}}
										>
											{button_text}
										</button>
									) : (
										<Link
											className="landing-link"
											to={getPathWithParams({
												path: businessRoutes.register,
												params: { language },
												app: 'business',
											})}
										>
											{button_text}
										</Link>
									)}
								</div>
							</div>
						)
					)}
				</div>
			</div>
		</div>
	</div>
);

export default Plan;
